export default function Transparency() {
  return (
    <div className="min-h-screen bg-white py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="font-heading font-bold text-section text-neutral-800 mb-8">
          Transparencia y Buen Gobierno
        </h1>

        <div className="prose prose-neutral max-w-none">
          <p className="lead text-lg text-neutral-600 mb-6">
            En cumplimiento de la Ley 19/2013, de 9 de diciembre, de transparencia, acceso a la
            información pública y buen gobierno, publicamos la siguiente información:
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            1. Actividades y Fines
          </h2>
          <p>
            Nuestra misión es democratizar el acceso a la educación cívica y facilitar la
            participación activa de la ciudadanía en procesos de cambio social.
          </p>
          <div className="bg-neutral-50 p-4 rounded-lg mt-4">
            <p className="font-semibold mb-2">Documentos disponibles:</p>
            <ul className="list-disc list-inside">
              <li>Acta Fundacional y Estatutos [PDF]</li>
              <li>Plan Estratégico 2025-2027 [PDF]</li>
              <li>Memoria de Actividades 2024 [PDF]</li>
            </ul>
          </div>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            2. Composición del Órgano de Gobierno
          </h2>
          <table className="min-w-full border border-neutral-300 mt-4">
            <thead>
              <tr className="bg-neutral-100">
                <th className="border border-neutral-300 px-4 py-2 text-left">Cargo</th>
                <th className="border border-neutral-300 px-4 py-2 text-left">Nombre</th>
                <th className="border border-neutral-300 px-4 py-2 text-left">Formación</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">Presidenta</td>
                <td className="border border-neutral-300 px-4 py-2">[Nombre]</td>
                <td className="border border-neutral-300 px-4 py-2">Doctora en Ciencias Políticas</td>
              </tr>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">Vicepresidente</td>
                <td className="border border-neutral-300 px-4 py-2">[Nombre]</td>
                <td className="border border-neutral-300 px-4 py-2">Licenciado en Sociología</td>
              </tr>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">Tesorera</td>
                <td className="border border-neutral-300 px-4 py-2">[Nombre]</td>
                <td className="border border-neutral-300 px-4 py-2">Economista</td>
              </tr>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">Secretario</td>
                <td className="border border-neutral-300 px-4 py-2">[Nombre]</td>
                <td className="border border-neutral-300 px-4 py-2">Abogado</td>
              </tr>
            </tbody>
          </table>
          <p className="text-sm text-neutral-600 mt-2">Actualizado: Enero 2025</p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            3. Presupuestos y Cuentas Anuales
          </h2>
          <div className="space-y-4 mt-4">
            <div className="bg-neutral-50 p-4 rounded-lg">
              <h3 className="font-semibold mb-2">Ejercicio 2024</h3>
              <ul className="list-disc list-inside text-sm">
                <li>Presupuesto aprobado: 350,000€ [PDF]</li>
                <li>Cuentas anuales auditadas [PDF]</li>
                <li>Informe de auditoría [PDF]</li>
              </ul>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg">
              <h3 className="font-semibold mb-2">Ejercicio 2023</h3>
              <ul className="list-disc list-inside text-sm">
                <li>Presupuesto ejecutado: 285,000€ [PDF]</li>
                <li>Cuentas anuales auditadas [PDF]</li>
                <li>Informe de auditoría [PDF]</li>
              </ul>
            </div>
          </div>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            4. Subvenciones y Ayudas Públicas Recibidas
          </h2>
          <table className="min-w-full border border-neutral-300 mt-4">
            <thead>
              <tr className="bg-neutral-100">
                <th className="border border-neutral-300 px-4 py-2 text-left">Año</th>
                <th className="border border-neutral-300 px-4 py-2 text-left">Administración</th>
                <th className="border border-neutral-300 px-4 py-2 text-left">Finalidad</th>
                <th className="border border-neutral-300 px-4 py-2 text-right">Importe</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">2024</td>
                <td className="border border-neutral-300 px-4 py-2">Ministerio de Educación</td>
                <td className="border border-neutral-300 px-4 py-2">Educación cívica digital</td>
                <td className="border border-neutral-300 px-4 py-2 text-right">120,000€</td>
              </tr>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">2024</td>
                <td className="border border-neutral-300 px-4 py-2">Comunidad de Madrid</td>
                <td className="border border-neutral-300 px-4 py-2">Participación ciudadana</td>
                <td className="border border-neutral-300 px-4 py-2 text-right">45,000€</td>
              </tr>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">2023</td>
                <td className="border border-neutral-300 px-4 py-2">Ayuntamiento de Barcelona</td>
                <td className="border border-neutral-300 px-4 py-2">Formación en presupuestos participativos</td>
                <td className="border border-neutral-300 px-4 py-2 text-right">30,000€</td>
              </tr>
            </tbody>
          </table>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            5. Contratos y Convenios con Administración Pública
          </h2>
          <table className="min-w-full border border-neutral-300 mt-4">
            <thead>
              <tr className="bg-neutral-100">
                <th className="border border-neutral-300 px-4 py-2 text-left">Objeto</th>
                <th className="border border-neutral-300 px-4 py-2 text-left">Entidad</th>
                <th className="border border-neutral-300 px-4 py-2 text-left">Duración</th>
                <th className="border border-neutral-300 px-4 py-2 text-right">Importe</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-neutral-300 px-4 py-2">Cursos de formación cívica</td>
                <td className="border border-neutral-300 px-4 py-2">Diputación de Valencia</td>
                <td className="border border-neutral-300 px-4 py-2">2024-2025</td>
                <td className="border border-neutral-300 px-4 py-2 text-right">55,000€</td>
              </tr>
            </tbody>
          </table>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            6. Retribuciones de Máximos Responsables
          </h2>
          <p>
            Como organización sin ánimo de lucro, los miembros del órgano de gobierno no perciben
            retribución alguna por sus funciones directivas. El personal contratado percibe
            retribuciones conforme al convenio colectivo aplicable.
          </p>

          <h2 className="font-heading font-semibold text-xl mt-8 mb-4">
            7. Contacto y Solicitud de Información
          </h2>
          <p>
            Para solicitar información adicional o ejercer tu derecho de acceso a la información
            pública:
          </p>
          <ul>
            <li>Email: transparencia@learnleadchange.org</li>
            <li>Teléfono: +34 XXX XXX XXX</li>
            <li>Plazo de respuesta: 30 días hábiles</li>
          </ul>

          <div className="bg-education-light bg-opacity-10 border-l-4 border-education p-4 mt-6">
            <p className="font-semibold text-education">Verificación de Cumplimiento</p>
            <p className="text-sm mt-2">
              Última actualización de datos: Enero 2025
              <br />
              Cumplimiento verificado conforme a la Ley 19/2013 de Transparencia
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
